import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ArticlesService {
  mainURL = 'api/articles';
  constructor(private http: HttpClient) {}

  getAllArticles() {
    return this.http.get(environment.apiUrl + this.mainURL);
  }

  getAllArticlesTranslation() {
    return this.http.get(environment.apiUrl + 'api/article-translations');
  }

  getArticleTranslation(id: string) {
    return this.http.get(environment.apiUrl + 'api/get-article-translation/' + id);
  }

  getOneArticle(id: string) {
    return this.http.get(environment.apiUrl + this.mainURL + '/' + id);
  }
}
